import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfileTags = (function ($) {

    function initEvents() {
        $(document).on('click', selector.addTag, events.addTagModal);
        $(document).on('click', selector.btnLostTag, events.openLostTagModal);
        $(document).on('click', selector.btnFoundTag, events.openFoundTagModal);
        $(document).on('click', selector.hr.tagType, events.hrTagTypeChange);
        $(document).on('click', selector.btnActivateTag, events.openActivateTagModal);
        $(document).on('click', selector.btnDeactivateTag, events.openDeactivateTagModal);
        $(document).ready(function() {
            $('#serial_number').select2({
                language: {
                    noResults: function() {
                        return "";
                    }
                }
            });
        });
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfileTags};
